import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import { useToggleLocation } from '../../contexts';

interface GoogleShowLocationProps {
  /** Optional tooltip text */
  tooltipText?: string;
  /** Icon color */
  color?:
    | 'inherit'
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  /** Icon size */
  size?: 'small' | 'medium' | 'large';
  /** Whether the button is disabled */
  disabled?: boolean;
  /** Additional class name */
  className?: string;
}

const GoogleShowLocation: React.FC<GoogleShowLocationProps> = ({
  tooltipText,
  color = 'default',
  size = 'medium',
  disabled = false,
  className,
}) => {
  const { locationEnabled, toggleLocation } = useToggleLocation();

  const handleClick = () => {
    toggleLocation();
  };

  const defaultTooltipText = locationEnabled
    ? 'Hide current location'
    : 'Show current location';

  const LocationIcon = locationEnabled ? LocationOnIcon : LocationOffIcon;

  return (
    <Tooltip title={tooltipText || defaultTooltipText}>
      <span>
        <IconButton
          onClick={handleClick}
          color={color}
          size={size}
          disabled={disabled}
          className={className}
          aria-label={locationEnabled ? 'Hide location' : 'Show location'}
        >
          <LocationIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default GoogleShowLocation;
